import { render, staticRenderFns } from "./ModalNotification.vue?vue&type=template&id=24e6b596&scoped=true"
import script from "./ModalNotification.vue?vue&type=script&lang=js"
export * from "./ModalNotification.vue?vue&type=script&lang=js"
import style0 from "./modal-notification.scss?vue&type=style&index=0&id=24e6b596&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e6b596",
  null
  
)

export default component.exports